import { fetchVideoApi } from 'common/api';
import { put } from 'redux-saga/effects';
import { errorHandleAction } from 'components/error-handle/actions';
import { myVideoSuccessAction } from 'pages/my-videos.page';
import { getUserEffect } from 'common/sagas/effects/get-user';

import { updateMyVideoUploaderAction, updateMyVideoResponsibleUserAction } from 'pages/my-videos.page/actions';

export function* myVideoRequestEffect({ payload }) {
  try {
    const video = yield fetchVideoApi(payload.videoId);

    try {
      if (video.uploaderUserId !== -1) {
        const videoUploader = yield* getUserEffect(video.uploaderUserId);
        yield put(updateMyVideoUploaderAction(videoUploader));
      }

      if (video.responsibleUserId !== -1) {
        const user = yield* getUserEffect(video.responsibleUserId);
        yield put(updateMyVideoResponsibleUserAction(user));
      }
    } catch (error) {
      // the user-service can't find users in edge-cases
    }

    yield put(myVideoSuccessAction(video));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
